<h2 mat-dialog-title>Configuração de Atualização de Voos</h2>

@if (loading) {
  <mat-progress-bar mode="indeterminate" />
}

<mat-dialog-content>
  <form [formGroup]="form" class="flex flex-col gap-4 pt-2">
    <mat-form-field appearance="outline" class="input-tg w-full">
      <mat-label>Intervalo de atualização (minutos)</mat-label>
      <input matInput type="number" formControlName="intervaloAtualizacaoMinutos" min="1" />
    </mat-form-field>

    <mat-slide-toggle formControlName="ativo">{{form.get('ativo') ? "Ativo" : "Inativo"}}</mat-slide-toggle>

    @if (config) {
      <div class="text-sm text-gray-500 flex flex-col gap-1 mt-2 border-t pt-3">
        <span><strong>Última atualização:</strong> {{ formatDate(config.ultimaAtualizacao) }}</span>
        <span><strong>Próxima atualização:</strong> {{ formatDate(config.proximaAtualizacao) }}</span>
        <span><strong>Voos atualizados na última execução:</strong> {{ config.voosAtualizadosUltimaExecucao }}</span>
      </div>
    }
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button class="btn-tg-white" (click)="close()">Cancelar</button>
  <button mat-button class="btn-tg" (click)="save()" [disabled]="form.invalid || loading">Salvar</button>
</mat-dialog-actions>
